export const EVENT_NAMESPACES = {
  PAY_WITH_GIFT_CARD: {
    TRANSFER: "evt_PayWithGiftCard_Transfer",
    BALANCE_CHECK: "evt_PayWithGiftCard_BalanceCheck",
  },
  MY_ACCOUNT: {
    TRANSFER: "evt_MyAccountGiftCard_Transfer",
    BALANCE_CHECK: "evt_MyAccountGiftCard_BalanceCheck",
  },
  MOBILE: {
    TRANSFER: "evt_EmbeddedGiftCard_Transfer",
    BALANCE_CHECK: "evt_EmbeddedGiftCard_BalanceCheck",
  },
  AUTHENTICATION: {
    LOGOUT: "evt_Logout",
  },
  APP_HEADER: {
    GLOBAL_APP_ALERT_ERROR: "evt_AppHeader_err",
  },
  CONFIRMATION: {
    APPLY_REWARD_ERROR: "evt_ApplyReward_err",
    APPLY_REWARD_INFO: "evt_ApplyReward_info",
  },
  APP_LOAD: {
  APP_CONFIG_LOAD: "evt_AppConfigLoad",
},
} as const;

/**
 * Retrieves the event namespace for a given source and module.
 * Works similarly to getLabel() for future-proofing and structure.
 */
export function getEventNamespace<
  Source extends keyof typeof EVENT_NAMESPACES,
  Module extends keyof typeof EVENT_NAMESPACES[Source],
>(
  source: Source,
  module: Module,
): string {
  return EVENT_NAMESPACES[source][module] as string;
}
